import React from 'react';
import styles from './DirectoryContent.module.css';
import { FigureFrame } from '../Decorative';

// Right pane: the [FIG. 2] framed window. Shows the empty-state prompt until a
// leaf is selected, then swaps in that leaf's placeholder body plus a
// [ COMING SOON ] note. Selection is in-page state only — no routing, no URL
// change.

function DirectoryContent({ selectedLeaf }) {
  return (
    <FigureFrame label="FIG. 2">
      <div className={styles.body}>
        {selectedLeaf ? (
          <div className={styles.content}>
            <p className={styles.text}>{selectedLeaf.placeholderBody}</p>
            <p className={styles.comingSoon}>[ COMING SOON ]</p>
          </div>
        ) : (
          <p className={styles.prompt} aria-live="polite">
            <span className={styles.promptText}>
              {'> select an item from the directory'}
            </span>
            <span className={styles.cursor} aria-hidden="true">
              ▋
            </span>
          </p>
        )}
      </div>
    </FigureFrame>
  );
}

export default DirectoryContent;
